import Link from 'next/link'
import React from 'react'

interface CityItemProps {
  name: string
  link: string
  closest: boolean
  lastCity?: boolean
  /** Fires after the user taps this chip. CitiesSection wires
   *  `home_city_tile_click` here so the analytics event carries the
   *  city slug + pillar + closest-to-geo flag without CityItem having
   *  to parse the link. */
  onTileClick?: () => void
}

const CityItem = ({
  name,
  link,
  closest,
  lastCity,
  onTileClick
}: CityItemProps) => (
  <Link
    href={link}
    onClick={onTileClick}
    className={`rounded-full px-3 py-1.5 text-xs font-semibold uppercase transition-all ${
      closest
        ? 'bg-blue-500 text-white-500 shadow-sm'
        : 'bg-cream-300 text-ink-700 hover:bg-blue-500/10 hover:text-blue-800'
    } ${lastCity ? 'hidden md:inline-block' : ''}`}
  >
    {name}
  </Link>
)

export default React.memo(CityItem)
